"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[588],{

/***/ 1588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CompanyListPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useIdentify/index.js
var useIdentify = __webpack_require__(205);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/HogProvider/index.js
var HogProvider = __webpack_require__(74313);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Row.js
var Row = __webpack_require__(39724);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Col.js
var Col = __webpack_require__(18978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./helpers/url.ts
var getParamFromUrl = function(key, url) {
    if (!url) {
        return "";
    }
    // Url doesn't have question mark
    if (url.indexOf("?") < 0) {
        return "";
    }
    var splittedUrl = url && url.split("?") || [];
    // splitted url array don't have 
    if (splittedUrl.length < 1) {
        return "";
    }
    var rawQueryString = splittedUrl[1];
    // Have query string with key but no value exist (No '=' in query string)
    if (rawQueryString.indexOf("=") < 0) {
        return "";
    }
    var queryArray = rawQueryString.split("&");
    var returnValue = "";
    for(var i = 0; i < queryArray.length; i++){
        var queryItem = queryArray[i].split("=");
        if (queryItem.length < 0) {
            continue;
        }
        if (queryItem[0] === key) {
            var ref;
            returnValue = (ref = queryItem[1]) !== null && ref !== void 0 ? ref : "";
            returnValue = decodeURIComponent(returnValue);
            break;
        }
    }
    return returnValue;
};

// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
// EXTERNAL MODULE: ./services/jobService.ts
var jobService = __webpack_require__(10656);
;// CONCATENATED MODULE: ./services/companyListService.ts





var COMPANY_LIST_API = "".concat("https://ms.vietnamworks.com", "/company-profile/v1.0/company/search");
var SUGGESTION_COMPANY_API = "".concat("https://ms.vietnamworks.com", "/hot-keywords/api/v2/keywords/suggestion-company");
var getCompanyList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(data, langCode, accessToken) {
        var headerParam, _tmp, requestOptions, _tmp1, responseCompanyList, ex, _tmp2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    headerParam = (_tmp["Content-Type"] = "application/json", _tmp["Accept-Language"] = langCode || constants/* ELanguage.VI */.Df.VI, _tmp);
                    if (accessToken !== "") {
                        headerParam.Authorization = "Bearer ".concat(accessToken);
                    }
                    _tmp1 = {};
                    requestOptions = (_tmp1.method = "POST", _tmp1.headers = headerParam, _tmp1.body = JSON.stringify(data), _tmp1);
                    return [
                        4,
                        fetch(COMPANY_LIST_API, requestOptions)
                    ];
                case 1:
                    responseCompanyList = _state.sent();
                    return [
                        4,
                        responseCompanyList.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    ex = _state.sent();
                    console.error(ex);
                    esm/* captureException */.Tb(ex);
                    _tmp2 = {};
                    return [
                        2,
                        (_tmp2.meta = {
                            code: jobService/* DEFAULT_ERROR_CODE */.mk,
                            message: "ERROR"
                        }, _tmp2.data = [], _tmp2)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCompanyList(data, langCode, accessToken) {
        return _ref.apply(this, arguments);
    };
}();
var getCompanySuggestion = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(keyword, limit, langCode) {
        var suggestionAPI, headerParam, _tmp, requestOptions, _tmp1, responseCompanyList, ex, _tmp2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    suggestionAPI = "".concat(SUGGESTION_COMPANY_API, "?query=").concat(keyword, "&limit=").concat(limit);
                    _tmp = {};
                    headerParam = (_tmp["Content-Type"] = "application/json", _tmp["Accept-Language"] = langCode || constants/* ELanguage.VI */.Df.VI, _tmp);
                    _tmp1 = {};
                    requestOptions = (_tmp1.method = "GET", _tmp1.headers = headerParam, _tmp1);
                    return [
                        4,
                        fetch(suggestionAPI, requestOptions)
                    ];
                case 1:
                    responseCompanyList = _state.sent();
                    return [
                        4,
                        responseCompanyList.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    ex = _state.sent();
                    console.error(ex);
                    esm/* captureException */.Tb(ex);
                    _tmp2 = {};
                    return [
                        2,
                        (_tmp2.data = [], _tmp2)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCompanySuggestion(keyword, limit, langCode) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./store/index.tsx + 1 modules
var store = __webpack_require__(13448);
// EXTERNAL MODULE: ./store/actions.ts
var actions = __webpack_require__(47806);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/dist/index.modern.js
var index_modern = __webpack_require__(64889);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/CompanyIndustry/index.js + 1 modules
var CompanyIndustry = __webpack_require__(21319);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/CompanyCardSquare/index.js + 6 modules
var CompanyCardSquare = __webpack_require__(15225);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
// EXTERNAL MODULE: ./components/Banner/Banner.css.tsx
var Banner_css = __webpack_require__(68276);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/CompanySearchResult/CompanySearchResult.css.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    /* background-color: #fff;\n    border-radius: 6px;\n    padding: 32px; */\n    @media (max-width: 768px) {\n        margin-bottom: 24px;\n    }\n    ",
        " {\n        h2 {\n            margin-bottom: 8px;\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #000;\n    font-weight: 700;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: #f6f8fb;\n    border-radius: 6px;\n    padding: 20px 44px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    p {\n        margin: 16px 0 0 0;\n        color: #777;\n        font-size:  14px;\n        line-height: 22px;\n        text-align: center;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #ff7d55;\n    font-weight: 700;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    color: #000;\n    @media (max-width: 768px) {\n        padding: 0 16px;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* @media (max-width: 768px) {\n        padding: 16px;\n        padding-bottom: 0;\n    } */\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    > div {\n        margin-bottom: 8px;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    padding-top: 16px;\n    @media (max-width: 768px) {\n        padding: 16px;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #005AFF !important;\n    cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var CompanySearchResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cdec9f9-0"
})(_templateObject(), Banner_css/* ContentWrapper */.vs);
var Keyword = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7cdec9f9-1"
})(_templateObject1());
var NoResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cdec9f9-2"
})(_templateObject2());
var KeywordCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7cdec9f9-3"
})(_templateObject3());
var SearchDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-7cdec9f9-4"
})(_templateObject4());
var CompanySearchResultList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cdec9f9-5"
})(_templateObject5());
var CompanySearchResultListLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cdec9f9-6"
})(_templateObject6());
var ViewMoreButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cdec9f9-7"
})(_templateObject7());
var ClearKeyword = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-7cdec9f9-8"
})(_templateObject8());

// EXTERNAL MODULE: ./components/constants.tsx
var components_constants = __webpack_require__(70586);
;// CONCATENATED MODULE: ./components/Icons/NoResultIcon/index.tsx


var NoResultIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "251",
        height: "109",
        viewBox: "0 0 251 109",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M167.44 81.5023L170.353 80.3008L171.308 82.6176L168.395 83.8191L167.44 81.5023Z",
                fill: "#D7D7D7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M173.317 60.6719L175.643 60.8017L175.539 62.6521L173.213 62.5227L173.317 60.6719Z",
                fill: "#D7D7D7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M160.618 94.2144L159.053 95.9422L157.682 94.6966L159.246 92.9688L160.618 94.2144Z",
                fill: "#D7D7D7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M147.832 82.8875L146.112 86.615L143.039 85.1962L144.759 81.4688L147.832 82.8875Z",
                fill: "#B8E7F8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M90.9438 13.0977L93.9111 14.1552L93.0718 16.5164L90.1045 15.459L90.9438 13.0977Z",
                fill: "#D7D7D7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M77.4022 26.9219L80.8889 29.0851L79.1078 31.9645L75.6211 29.8013L77.4022 26.9219Z",
                fill: "#B8E7F8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "109.438",
                cy: "65.8015",
                rx: "23.8617",
                ry: "23.8836",
                stroke: "#B8E7F8",
                strokeOpacity: "0.764",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M98.1282 57.5835C98.2179 57.4978 98.3396 57.4492 98.4665 57.4492H119.516C119.643 57.4492 119.765 57.4978 119.855 57.5835C119.944 57.6697 119.995 57.7862 119.995 57.9076V71.2002H120.474C120.6 71.2002 120.722 71.2483 120.812 71.3345C120.902 71.4203 120.952 71.5368 120.952 71.6586V72.5753C120.952 73.1801 120.796 73.6809 120.422 74.0041C120.048 74.327 119.555 74.4087 119.038 74.4087H98.9449C98.6045 74.4087 98.176 74.3152 97.7732 74.0345C97.3703 73.7537 97.0312 73.2436 97.0312 72.5753V71.6586C97.0312 71.5368 97.0817 71.4203 97.1714 71.3345C97.2611 71.2483 97.3828 71.2002 97.5097 71.2002H97.9881V57.9076C97.9881 57.7862 98.0385 57.6697 98.1282 57.5835ZM109.857 62.9952C110.048 62.7662 110.191 62.3997 110.144 62.0327C109.809 62.0789 109.426 62.2617 109.187 62.5368C108.948 62.8119 108.804 63.1327 108.9 63.4535C109.283 63.4535 109.618 63.2703 109.857 62.9952ZM107.895 63.4535C108.148 63.4535 108.361 63.5302 108.561 63.6026C108.741 63.6673 108.911 63.7286 109.092 63.7286C109.264 63.7286 109.407 63.673 109.564 63.6118C109.757 63.5369 109.972 63.4535 110.288 63.4535C110.718 63.4535 111.149 63.6833 111.484 64.0498C110.431 64.6 110.623 66.0204 111.675 66.433C111.615 66.5345 111.564 66.6177 111.518 66.6926C111.418 66.8546 111.342 66.9783 111.244 67.1661L111.222 67.1941C110.938 67.5582 110.563 68.0374 110.144 68.0374C109.949 68.0374 109.822 67.981 109.694 67.9235C109.538 67.8541 109.379 67.7831 109.092 67.8081C108.8 67.8081 108.632 67.879 108.48 67.9429C108.334 68.0048 108.203 68.0599 107.991 68.0374C107.512 68.0374 107.178 67.6252 106.939 67.2126C106.221 66.1583 106.126 64.8743 106.604 64.187C106.939 63.7286 107.417 63.4535 107.895 63.4535ZM105.643 72.1169H97.9881V72.5753C97.9881 72.9762 98.1366 73.1538 98.3366 73.2933C98.5366 73.4325 98.826 73.492 98.9449 73.492H119.038C119.445 73.492 119.67 73.4208 119.782 73.3237C119.894 73.2266 119.995 73.0397 119.995 72.5753V72.1169H119.516H112.34C112.34 72.2383 112.29 72.3548 112.2 72.441C112.111 72.5267 111.989 72.5753 111.862 72.5753H106.121C105.994 72.5753 105.873 72.5267 105.783 72.441C105.693 72.3548 105.643 72.2383 105.643 72.1169Z",
                fill: "#B8E7F8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M129.602 13.4473C129.602 12.4905 130.377 11.7148 131.334 11.7148H171.501C172.458 11.7148 173.234 12.4905 173.234 13.4473V66.6381C173.234 67.5949 172.458 68.3706 171.501 68.3706H131.334C130.377 68.3706 129.602 67.5949 129.602 66.6381V13.4473Z",
                fill: "#E0E0E0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M167.252 15.2539C166.478 15.2539 165.845 15.8116 165.845 16.4933V16.8031H165.141C164.93 16.8031 164.789 16.927 164.789 17.1129V19.9014C164.789 20.0873 164.93 20.2113 165.141 20.2113H169.363C169.575 20.2113 169.715 20.0873 169.715 19.9014V17.1129C169.715 16.927 169.575 16.8031 169.363 16.8031H168.66V16.4933C168.66 15.8116 168.026 15.2539 167.252 15.2539ZM167.604 18.879V19.2818H166.9V18.879C166.689 18.786 166.548 18.5692 166.548 18.3523C166.548 18.0114 166.865 17.7326 167.252 17.7326C167.639 17.7326 167.956 18.0114 167.956 18.3523C167.956 18.5692 167.815 18.786 167.604 18.879ZM166.548 16.4933V16.8031H167.956V16.4933C167.956 16.1524 167.639 15.8736 167.252 15.8736C166.865 15.8736 166.548 16.1524 166.548 16.4933Z",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_386_26854",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "143",
                y: "20",
                width: "17",
                height: "16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M143.753 20.5664H159.083V35.9107H143.753V20.5664Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_386_26854)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M152.642 33.5419C152.821 33.7788 153.028 33.9938 153.258 34.179L152.165 35.2901C151.995 35.4661 151.717 35.4661 151.547 35.2901C151.375 35.1165 151.375 34.8338 151.547 34.6602L152.642 33.5419ZM155.47 29.5599C155.337 29.5599 155.23 29.6691 155.23 29.8042C155.23 29.9392 155.337 30.0484 155.47 30.0484C155.959 30.0484 156.399 30.3448 156.591 30.804C156.63 30.8967 156.718 30.9522 156.811 30.9522C156.842 30.9522 156.875 30.9464 156.905 30.9327C157.027 30.8801 157.083 30.7363 157.031 30.6124C156.764 29.9733 156.151 29.5599 155.47 29.5599V29.5599ZM155.47 29.1139C156.646 29.1139 157.605 30.0908 157.605 31.2911C157.605 32.4913 156.646 33.4683 155.47 33.4683C154.292 33.4683 153.334 32.4913 153.334 31.2911C153.334 30.0908 154.292 29.1139 155.47 29.1139V29.1139ZM155.47 28.6259C154.028 28.6259 152.855 29.8212 152.855 31.2911C152.855 32.7604 154.028 33.9567 155.47 33.9567C156.911 33.9567 158.084 32.7604 158.084 31.2911C158.084 29.8212 156.911 28.6259 155.47 28.6259V28.6259ZM155.49 28.1374C156.599 28.1374 157.574 28.7307 158.125 29.6218C158.429 30.1128 158.604 30.6919 158.604 31.312C158.604 32.0447 158.357 32.7238 157.945 33.2611C157.378 34.006 156.489 34.4867 155.49 34.4867C154.872 34.4867 154.297 34.3034 153.813 33.986C153.516 33.7905 153.252 33.5492 153.037 33.2659C152.967 33.1777 152.906 33.0851 152.848 32.9871C152.805 32.9188 152.764 32.8482 152.728 32.7775C152.575 32.4767 152.464 32.1471 152.414 31.8005C152.388 31.6421 152.376 31.4783 152.376 31.312C152.376 29.5609 153.773 28.1374 155.49 28.1374V28.1374ZM150.939 28.1374H151.897V26.6719H150.939V28.1374ZM144.711 26.3541L150.46 27.6806V28.1374C150.46 28.406 150.675 28.6259 150.939 28.6259H151.897C152.16 28.6259 152.376 28.406 152.376 28.1374V27.6806L158.125 26.3541V28.8262C157.468 28.1033 156.53 27.6489 155.49 27.6489C153.509 27.6489 151.897 29.2923 151.897 31.312H145.43C145.298 31.312 145.19 31.4217 145.19 31.5563C145.19 31.6908 145.298 31.8005 145.43 31.8005H151.931C151.974 32.1447 152.067 32.4723 152.199 32.7775H144.951C144.819 32.7775 144.711 32.6678 144.711 32.5332V26.3541ZM157.406 23.0088C157.274 23.0088 157.167 23.118 157.167 23.2531V23.741C157.167 23.8761 157.274 23.9853 157.406 23.9853C157.539 23.9853 157.646 23.8761 157.646 23.741V23.2531C157.646 23.118 157.539 23.0088 157.406 23.0088V23.0088ZM156.208 23.0088C156.076 23.0088 155.969 23.118 155.969 23.2531V23.741C155.969 23.8761 156.076 23.9853 156.208 23.9853C156.341 23.9853 156.448 23.8761 156.448 23.741V23.2531C156.448 23.118 156.341 23.0088 156.208 23.0088V23.0088ZM155.011 23.0088C154.879 23.0088 154.772 23.118 154.772 23.2531V23.741C154.772 23.8761 154.879 23.9853 155.011 23.9853C155.143 23.9853 155.251 23.8761 155.251 23.741V23.2531C155.251 23.118 155.143 23.0088 155.011 23.0088V23.0088ZM153.813 23.0088C153.681 23.0088 153.574 23.118 153.574 23.2531V23.741C153.574 23.8761 153.681 23.9853 153.813 23.9853C153.946 23.9853 154.053 23.8761 154.053 23.741V23.2531C154.053 23.118 153.946 23.0088 153.813 23.0088V23.0088ZM152.616 23.0088C152.483 23.0088 152.376 23.118 152.376 23.2531V23.741C152.376 23.8761 152.483 23.9853 152.616 23.9853C152.748 23.9853 152.855 23.8761 152.855 23.741V23.2531C152.855 23.118 152.748 23.0088 152.616 23.0088V23.0088ZM151.418 23.0088C151.286 23.0088 151.178 23.118 151.178 23.2531V23.741C151.178 23.8761 151.286 23.9853 151.418 23.9853C151.55 23.9853 151.657 23.8761 151.657 23.741V23.2531C151.657 23.118 151.55 23.0088 151.418 23.0088V23.0088ZM150.22 23.0088C150.088 23.0088 149.981 23.118 149.981 23.2531V23.741C149.981 23.8761 150.088 23.9853 150.22 23.9853C150.352 23.9853 150.46 23.8761 150.46 23.741V23.2531C150.46 23.118 150.352 23.0088 150.22 23.0088V23.0088ZM149.023 23.0088C148.89 23.0088 148.783 23.118 148.783 23.2531V23.741C148.783 23.8761 148.89 23.9853 149.023 23.9853C149.155 23.9853 149.262 23.8761 149.262 23.741V23.2531C149.262 23.118 149.155 23.0088 149.023 23.0088V23.0088ZM147.825 23.0088C147.692 23.0088 147.585 23.118 147.585 23.2531V23.741C147.585 23.8761 147.692 23.9853 147.825 23.9853C147.957 23.9853 148.064 23.8761 148.064 23.741V23.2531C148.064 23.118 147.957 23.0088 147.825 23.0088V23.0088ZM146.627 23.0088C146.495 23.0088 146.388 23.118 146.388 23.2531V23.741C146.388 23.8761 146.495 23.9853 146.627 23.9853C146.76 23.9853 146.867 23.8761 146.867 23.741V23.2531C146.867 23.118 146.76 23.0088 146.627 23.0088V23.0088ZM145.43 23.0088C145.297 23.0088 145.19 23.118 145.19 23.2531V23.741C145.19 23.8761 145.297 23.9853 145.43 23.9853C145.562 23.9853 145.669 23.8761 145.669 23.741V23.2531C145.669 23.118 145.562 23.0088 145.43 23.0088V23.0088ZM144.472 22.5203H148.336H154.5H158.364C158.496 22.5203 158.604 22.63 158.604 22.7646V23.0088C158.472 23.0088 158.364 23.118 158.364 23.2531V23.741C158.364 23.8761 158.472 23.9853 158.604 23.9853V25.1577C158.604 25.4732 158.412 25.7466 158.125 25.849C158.099 25.8588 158.072 25.8661 158.044 25.8734L152.376 27.1775V26.6719C152.376 26.4033 152.16 26.1835 151.897 26.1835H150.939C150.675 26.1835 150.46 26.4033 150.46 26.6719V27.1775L144.792 25.8734C144.764 25.8661 144.737 25.8588 144.711 25.849C144.424 25.7466 144.232 25.4732 144.232 25.1577V23.9853C144.364 23.9853 144.472 23.8761 144.472 23.741V23.2531C144.472 23.118 144.364 23.0088 144.232 23.0088V22.7646C144.232 22.63 144.34 22.5203 144.472 22.5203V22.5203ZM149.998 21.0549H152.838C152.919 21.0549 152.993 21.0953 153.038 21.1636L153.605 22.0318H149.231L149.798 21.1636C149.843 21.0953 149.917 21.0549 149.998 21.0549V21.0549ZM149.998 20.5664C149.757 20.5664 149.533 20.6883 149.399 20.8925L148.655 22.0319H144.472C144.076 22.0319 143.753 22.3614 143.753 22.7646V25.1577C143.753 25.556 143.935 25.9124 144.232 26.1347V32.5332C144.232 32.9359 144.555 33.2659 144.951 33.2659H152.237L151.207 34.3131C150.85 34.6792 150.85 35.2711 151.207 35.6372C151.387 35.818 151.621 35.9107 151.856 35.9107C152.091 35.9107 152.325 35.818 152.505 35.6372L153.602 34.5159C153.622 34.4964 153.638 34.4798 153.653 34.4579C154.189 34.7875 154.819 34.9751 155.49 34.9751C157.471 34.9751 159.083 33.3318 159.083 31.312C159.083 30.6475 158.908 30.025 158.604 29.4878V26.1347C158.901 25.9124 159.083 25.556 159.083 25.1577V22.7646C159.083 22.3614 158.759 22.0319 158.364 22.0319H154.181L153.436 20.8925C153.303 20.6883 153.079 20.5664 152.838 20.5664H149.998Z",
                    fill: "#C2C2C2"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "137.343",
                y: "43.582",
                width: "28.1497",
                height: "1.41639",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "137.343",
                y: "47.1211",
                width: "28.1497",
                height: "1.41639",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "137.343",
                y: "50.6641",
                width: "28.1497",
                height: "1.41639",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "137.343",
                y: "54.9141",
                width: "28.1497",
                height: "1.41639",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "145.084",
                y: "58.4531",
                width: "12.6674",
                height: "1.41639",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.7797 22.1562H135.382C136.196 22.1562 136.857 22.8166 136.857 23.6312V95.4026C136.857 96.2172 136.196 96.8776 135.382 96.8776H80.7797C79.9651 96.8776 79.3047 96.2172 79.3047 95.4026V23.6313C79.3047 22.8166 79.9651 22.1562 80.7797 22.1562Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.7797 22.1562H135.382C136.196 22.1562 136.857 22.8166 136.857 23.6312V95.4026C136.857 96.2172 136.196 96.8776 135.382 96.8776H80.7797C79.9651 96.8776 79.3047 96.2172 79.3047 95.4026V23.6313C79.3047 22.8166 79.9651 22.1562 80.7797 22.1562Z",
                stroke: "#B8E7F8",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M80.7797 22.1562H135.382C136.196 22.1562 136.857 22.8166 136.857 23.6312V95.4026C136.857 96.2172 136.196 96.8776 135.382 96.8776H80.7797C79.9651 96.8776 79.3047 96.2172 79.3047 95.4026V23.6313C79.3047 22.8166 79.9651 22.1562 80.7797 22.1562Z",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M126.405 30.8047C125.625 30.8047 124.987 31.4382 124.987 32.2124V32.5644H124.278C124.066 32.5644 123.924 32.7051 123.924 32.9163V36.0837C123.924 36.2948 124.066 36.4356 124.278 36.4356H128.532C128.745 36.4356 128.886 36.2948 128.886 36.0837V32.9163C128.886 32.7051 128.745 32.5644 128.532 32.5644H127.823V32.2124C127.823 31.4382 127.185 30.8047 126.405 30.8047ZM126.76 34.9223V35.3798H126.051V34.9223C125.838 34.8167 125.696 34.5704 125.696 34.324C125.696 33.9369 126.015 33.6201 126.405 33.6201C126.795 33.6201 127.114 33.9369 127.114 34.324C127.114 34.5704 126.972 34.8167 126.76 34.9223ZM125.696 32.2124V32.5644H127.114V32.2124C127.114 31.8253 126.795 31.5086 126.405 31.5086C126.015 31.5086 125.696 31.8253 125.696 32.2124Z",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.9",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M110.164 51.9251C110.427 52.2714 110.728 52.5852 111.064 52.8562L109.468 54.4799C109.219 54.7373 108.813 54.7373 108.565 54.4799C108.312 54.2268 108.312 53.8135 108.565 53.56L110.164 51.9251ZM114.297 46.1054C114.104 46.1054 113.947 46.2652 113.947 46.4624C113.947 46.6596 114.104 46.8194 114.297 46.8194C115.012 46.8194 115.655 47.2527 115.936 47.9234C115.993 48.0594 116.122 48.1405 116.258 48.1405C116.304 48.1405 116.351 48.1313 116.395 48.1119C116.573 48.0342 116.656 47.8243 116.58 47.6437C116.189 46.7092 115.293 46.1054 114.297 46.1054V46.1054ZM114.297 45.4536C116.018 45.4536 117.418 46.8811 117.418 48.6355C117.418 50.3898 116.018 51.8173 114.297 51.8173C112.576 51.8173 111.177 50.3898 111.177 48.6355C111.177 46.8811 112.576 45.4536 114.297 45.4536V45.4536ZM114.297 44.7401C112.19 44.7401 110.476 46.4872 110.476 48.6354C110.476 50.7832 112.19 52.5313 114.297 52.5313C116.404 52.5313 118.118 50.7832 118.118 48.6354C118.118 46.4872 116.404 44.7401 114.297 44.7401V44.7401ZM114.327 44.0257C115.948 44.0257 117.373 44.8931 118.178 46.1963C118.622 46.9136 118.878 47.7592 118.878 48.6661C118.878 49.737 118.518 50.7293 117.915 51.5147C117.086 52.6031 115.787 53.3059 114.327 53.3059C113.424 53.3059 112.584 53.0383 111.876 52.574C111.442 52.2889 111.057 51.9353 110.742 51.5215C110.641 51.3928 110.55 51.2573 110.466 51.1145C110.403 51.0144 110.343 50.9114 110.291 50.8075C110.067 50.3684 109.906 49.8866 109.832 49.38C109.794 49.1479 109.776 48.9089 109.776 48.6661C109.776 46.1069 111.817 44.0257 114.327 44.0257V44.0257ZM107.676 44.0257H109.076V41.8842H107.676V44.0257ZM98.5734 41.4204L106.975 43.3588V44.0257C106.975 44.4186 107.29 44.7401 107.676 44.7401H109.076C109.461 44.7401 109.776 44.4186 109.776 44.0257V43.3588L118.178 41.4204V45.0325C117.219 43.9761 115.847 43.3122 114.327 43.3122C111.432 43.3122 109.076 45.714 109.076 48.6661H99.6238C99.4309 48.6661 99.2737 48.8268 99.2737 49.023C99.2737 49.2193 99.4309 49.38 99.6238 49.38H109.125C109.188 49.8832 109.324 50.3616 109.517 50.8075H98.9236C98.7311 50.8075 98.5734 50.6472 98.5734 50.4505V41.4204ZM117.128 36.5303C116.935 36.5303 116.777 36.6901 116.777 36.8873V37.6013C116.777 37.7985 116.935 37.9583 117.128 37.9583C117.321 37.9583 117.478 37.7985 117.478 37.6013V36.8873C117.478 36.6901 117.321 36.5303 117.128 36.5303V36.5303ZM115.377 36.5303C115.184 36.5303 115.027 36.6901 115.027 36.8873V37.6013C115.027 37.7985 115.184 37.9583 115.377 37.9583C115.571 37.9583 115.727 37.7985 115.727 37.6013V36.8873C115.727 36.6901 115.571 36.5303 115.377 36.5303V36.5303ZM113.627 36.5303C113.434 36.5303 113.277 36.6901 113.277 36.8873V37.6013C113.277 37.7985 113.434 37.9583 113.627 37.9583C113.82 37.9583 113.977 37.7985 113.977 37.6013V36.8873C113.977 36.6901 113.82 36.5303 113.627 36.5303V36.5303ZM111.876 36.5303C111.683 36.5303 111.526 36.6901 111.526 36.8873V37.6013C111.526 37.7985 111.683 37.9583 111.876 37.9583C112.07 37.9583 112.227 37.7985 112.227 37.6013V36.8873C112.227 36.6901 112.07 36.5303 111.876 36.5303V36.5303ZM110.126 36.5303C109.933 36.5303 109.776 36.6901 109.776 36.8873V37.6013C109.776 37.7985 109.933 37.9583 110.126 37.9583C110.32 37.9583 110.476 37.7985 110.476 37.6013V36.8873C110.476 36.6901 110.32 36.5303 110.126 36.5303V36.5303ZM108.376 36.5303C108.183 36.5303 108.026 36.6901 108.026 36.8873V37.6013C108.026 37.7985 108.183 37.9583 108.376 37.9583C108.569 37.9583 108.726 37.7985 108.726 37.6013V36.8873C108.726 36.6901 108.569 36.5303 108.376 36.5303V36.5303ZM106.625 36.5303C106.432 36.5303 106.275 36.6901 106.275 36.8873V37.6013C106.275 37.7985 106.432 37.9583 106.625 37.9583C106.819 37.9583 106.975 37.7985 106.975 37.6013V36.8873C106.975 36.6901 106.819 36.5303 106.625 36.5303V36.5303ZM104.875 36.5303C104.682 36.5303 104.525 36.6901 104.525 36.8873V37.6013C104.525 37.7985 104.682 37.9583 104.875 37.9583C105.068 37.9583 105.225 37.7985 105.225 37.6013V36.8873C105.225 36.6901 105.068 36.5303 104.875 36.5303V36.5303ZM103.124 36.5303C102.931 36.5303 102.774 36.6901 102.774 36.8873V37.6013C102.774 37.7985 102.931 37.9583 103.124 37.9583C103.318 37.9583 103.474 37.7985 103.474 37.6013V36.8873C103.474 36.6901 103.318 36.5303 103.124 36.5303V36.5303ZM101.374 36.5303C101.181 36.5303 101.024 36.6901 101.024 36.8873V37.6013C101.024 37.7985 101.181 37.9583 101.374 37.9583C101.567 37.9583 101.724 37.7985 101.724 37.6013V36.8873C101.724 36.6901 101.567 36.5303 101.374 36.5303V36.5303ZM99.6238 36.5303C99.4304 36.5303 99.2737 36.6901 99.2737 36.8873V37.6013C99.2737 37.7985 99.4304 37.9583 99.6238 37.9583C99.8168 37.9583 99.9735 37.7985 99.9735 37.6013V36.8873C99.9735 36.6901 99.8168 36.5303 99.6238 36.5303V36.5303ZM98.2233 35.8164H103.87H112.88H118.528C118.721 35.8164 118.878 35.9771 118.878 36.1734V36.5303C118.685 36.5303 118.528 36.6901 118.528 36.8873V37.6013C118.528 37.7985 118.685 37.9583 118.878 37.9583V39.6714C118.878 40.1323 118.598 40.532 118.178 40.6821C118.139 40.6962 118.101 40.7064 118.059 40.7176L109.776 42.6235V41.8842C109.776 41.4918 109.461 41.1702 109.076 41.1702H107.676C107.29 41.1702 106.975 41.4918 106.975 41.8842V42.6235L98.692 40.7176C98.6506 40.7064 98.612 40.6962 98.5734 40.6821C98.1532 40.532 97.8731 40.1323 97.8731 39.6714V37.9583C98.0661 37.9583 98.2233 37.7985 98.2233 37.6013V36.8873C98.2233 36.6901 98.0661 36.5303 97.8731 36.5303V36.1734C97.8731 35.9771 98.0308 35.8164 98.2233 35.8164V35.8164ZM106.3 33.6749H110.452C110.569 33.6749 110.678 33.7342 110.743 33.8337L111.572 35.1029H105.179L106.008 33.8337C106.074 33.7342 106.183 33.6749 106.3 33.6749V33.6749ZM106.3 32.9609C105.948 32.9609 105.621 33.1392 105.426 33.4379L104.338 35.1029H98.2233C97.6454 35.1029 97.1729 35.5842 97.1729 36.1734V39.6714C97.1729 40.2532 97.4391 40.7744 97.8731 41.0993V50.4505C97.8731 51.0397 98.3457 51.5215 98.9236 51.5215H109.573L108.067 53.0524C107.546 53.5876 107.546 54.4522 108.067 54.9874C108.33 55.2517 108.673 55.3872 109.016 55.3872C109.36 55.3872 109.702 55.2517 109.965 54.9874L111.568 53.3487C111.596 53.32 111.621 53.2957 111.642 53.2637C112.426 53.7455 113.347 54.0199 114.327 54.0199C117.222 54.0199 119.579 51.6181 119.579 48.6661C119.579 47.6951 119.323 46.7849 118.878 45.9996V41.0993C119.312 40.7744 119.579 40.2532 119.579 39.6714V36.1734C119.579 35.5842 119.106 35.1029 118.528 35.1029H112.414L111.326 33.4379C111.13 33.1392 110.804 32.9609 110.452 32.9609H106.3Z",
                fill: "#C2C2C2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "87.5215",
                y: "68.8125",
                width: "41.1192",
                height: "1.40773",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "87.5215",
                y: "74.4453",
                width: "41.1192",
                height: "1.40773",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "87.5215",
                y: "79.3711",
                width: "41.1192",
                height: "1.40773",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "87.5215",
                y: "85.0039",
                width: "41.1192",
                height: "1.40773",
                fill: "#E5E7EB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "98.8643",
                y: "89.9297",
                width: "18.4327",
                height: "1.40773",
                fill: "#E5E7EB"
            })
        ]
    });
};
/* harmony default export */ var Icons_NoResultIcon = (/*#__PURE__*/react.memo(NoResultIcon));

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/responsiveHelper.js
var responsiveHelper = __webpack_require__(67430);
;// CONCATENATED MODULE: ./components/CompanyListSection/CompanyListSection.css.tsx

function CompanyListSection_css_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 32px;\n    right: 32px;\n"
    ]);
    CompanyListSection_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyListSection_css_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    > div {\n        padding: 32px 32px 16px 32px;\n        @media screen and (max-width: ",
        "px) {\n            padding: 16px;\n            background-color: transparent;\n            border: none;\n            padding: 0;\n        }\n    }\n    h2 {\n        margin-bottom: 16px;\n        line-height: 28px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        span {\n            color: #999;\n            font-size: 24px;\n            margin-left: 4px;\n        }\n    }\n    ",
        " {\n        @media screen and (max-width: ",
        "px) {\n            h2 {\n                display: block;\n                font-weight: 700;\n                height: initial;\n                margin-bottom: 8px;\n                span {\n                    color: #999;\n                    font-size: 14px;\n                    font-weight: 400;\n                }\n            }\n            ",
        " {\n                display: block;\n                position: relative;\n                top: initial;\n                right: initial;\n                margin-bottom: 8px;\n            }\n        }\n    }\n"
    ]);
    CompanyListSection_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyListSection_css_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n"
    ]);
    CompanyListSection_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyListSection_css_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    left: 0;\n    top: 0;\n    display: flex;\n    background-color: #fff;\n    z-index: 10;\n    width: 100%;\n    > div {\n        margin-right: 16px;\n        width: 33.3%;\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n"
    ]);
    CompanyListSection_css_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanyListSection_css_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n"
    ]);
    CompanyListSection_css_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var CompanyFilter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-219887f4-0"
})(CompanyListSection_css_templateObject());
var CompanyListSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-219887f4-1"
})(CompanyListSection_css_templateObject1(), responsiveHelper/* screens.mobile */.FB.mobile, Banner_css/* ContentWrapper */.vs, responsiveHelper/* screens.mobile */.FB.mobile, CompanyFilter);
var CompanySlider = (0,styled_components_browser_esm/* default */.ZP)(Row/* default */.Z).withConfig({
    componentId: "sc-219887f4-2"
})(CompanyListSection_css_templateObject2());
var OverlayLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-219887f4-3"
})(CompanyListSection_css_templateObject3());
var LoadMoreAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-219887f4-4"
})(CompanyListSection_css_templateObject4());

;// CONCATENATED MODULE: ./components/CompanyListSection/translation.ts
var translations = {
    Search: "T\xecm",
    "All categories": "Tất cả ng\xe0nh nghề",
    "View more": "Xem th\xeam",
    "No results found": "Kh\xf4ng c\xf3 kết quả",
    "There is no company matches with your search": "Từ kho\xe1 t\xecm kiếm của bạn kh\xf4ng khớp với t\xean c\xf4ng ty n\xe0o",
    "We found": "Ch\xfang t\xf4i t\xecm thấy",
    "companies matching with": "c\xf4ng ty ph\xf9 hợp với",
    "company matching with": "c\xf4ng ty ph\xf9 hợp với",
    "category": "ng\xe0nh",
    "categories": "ng\xe0nh",
    "industries": "lĩnh vực",
    "industry": "lĩnh vực",
    "Clear filter": "Xo\xe1 bộ lọc"
};
/* harmony default export */ var translation = (translations);

;// CONCATENATED MODULE: ./components/CompanyListSection/index.tsx
















var CompanyListSection = function(props) {
    var ref, ref1;
    var title = props.title, langCode = props.langCode;
    var ref2 = (0,store.useStore)(), state = ref2.state, dispatch = ref2.dispatch;
    var isMobile = state.isMobile, user = state.user, companyList = state.companyList;
    // Industries Filter
    var ref3 = (0,react.useState)([
        -1
    ]), selectedIndustries = ref3[0], setSelectedIndustries = ref3[1];
    // Pagination, load more button
    var ref4 = (0,react.useState)(0), currentPage = ref4[0], setCurrentPage = ref4[1];
    var ref5 = (0,react.useState)(true), isShowLoadMoreButton = ref5[0], setShowLoadMoreButton = ref5[1];
    var currentCompanyCount = (0,react.useRef)(0);
    var t = function(text) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        } else {
            return translation[text];
        }
    };
    var handleOnChangeFilterIndustries = function(industryId) {
        setSelectedIndustries(Array.isArray(industryId) ? industryId : [
            industryId
        ]);
        dispatch({
            type: actions/* ACTION_SET_COMPANY_LIST */.jM,
            payload: []
        });
        getMoreCompanies(0, Array.isArray(industryId) ? industryId : [
            industryId
        ]);
    };
    var getMoreCompanies = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(page, industries) {
            var ref, rangesFilter, _tmp, filters, _tmp1, _tmp2, featuredCompanyList, _tmp3, companyResponseList, _tmp4, totalCompanies, latestCompany;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowLoadMoreButton(false);
                        _tmp = {};
                        rangesFilter = [
                            (_tmp.field = "companyId", _tmp.operator = ">", _tmp.value = "0", _tmp)
                        ];
                        setCurrentPage(page);
                        _tmp1 = {};
                        filters = [
                            (_tmp1.field = "profilePublishedSiteMask", _tmp1.value = "1,3", _tmp1)
                        ];
                        _tmp2 = {};
                        if (industries.length > 0 && industries[0] !== -1) {
                            filters.push((_tmp2.field = "industriesV3CCP.industryV3Id", _tmp2.value = industries.join(","), _tmp2));
                        }
                        _tmp3 = {};
                        return [
                            4,
                            getCompanyList((_tmp3.query = "", _tmp3.order = [
                                {
                                    field: "lastPostJobOn",
                                    value: "desc"
                                }
                            ], _tmp3.hitsPerPage = components_constants/* LIMIT_COMPANY_LIST */.jg, _tmp3.filter = filters, _tmp3.page = page, _tmp3.ranges = rangesFilter, _tmp3.userId = user === null || user === void 0 ? void 0 : user.userId, _tmp3.regexp = [
                                {
                                    field: "companySlug",
                                    value: ".+"
                                }
                            ], _tmp3.isJobs = true, _tmp3), langCode, (user === null || user === void 0 ? void 0 : user.accessToken) || "")
                        ];
                    case 1:
                        featuredCompanyList = _state.sent();
                        companyResponseList = (0,_to_consumable_array/* default */.Z)(companyList);
                        if (page === 0) {
                            companyResponseList = [
                                featuredCompanyList
                            ];
                        } else {
                            companyResponseList.push(featuredCompanyList);
                        }
                        _tmp4 = {};
                        dispatch((_tmp4.type = actions/* ACTION_SET_COMPANY_LIST */.jM, _tmp4.payload = companyResponseList, _tmp4));
                        totalCompanies = 0;
                        companyResponseList.map(function(companyResponse) {
                            totalCompanies += companyResponse.data.length;
                        });
                        currentCompanyCount.current = totalCompanies;
                        latestCompany = companyResponseList[companyResponseList.length - 1];
                        if (totalCompanies < ((latestCompany === null || latestCompany === void 0 ? void 0 : (ref = latestCompany.meta) === null || ref === void 0 ? void 0 : ref.nbHits) || 0)) {
                            setShowLoadMoreButton(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getMoreCompanies(page, industries) {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickViewMore = function() {
        var ref;
        var latestCompany = companyList[companyList.length - 1];
        if (currentCompanyCount.current >= ((latestCompany === null || latestCompany === void 0 ? void 0 : (ref = latestCompany.meta) === null || ref === void 0 ? void 0 : ref.nbHits) || 0)) {
            return;
        }
        // Do get more
        getMoreCompanies(currentPage + 1, selectedIndustries);
    };
    var onClearFilter = function() {
        setSelectedIndustries([
            -1
        ]);
        dispatch({
            type: actions/* ACTION_SET_COMPANY_LIST */.jM,
            payload: []
        });
        getMoreCompanies(0, [
            -1
        ]);
    };
    var companyListMapped = [];
    companyList.map(function(companyResponse) {
        companyResponse === null || companyResponse === void 0 ? void 0 : companyResponse.data.map(function(companyInfo) {
            return companyListMapped.push(companyInfo);
        });
    });
    // Get list company name
    var mappedCompaniesName = [];
    if (companyListMapped.length === 0) {
        var industries = index_modern/* initialDataProvider.getIndustries */.Bz.getIndustries();
        mappedCompaniesName = selectedIndustries.map(function(industryId) {
            if (industries.length > 0) {
                return langCode === constants/* ELanguage.EN */.Df.EN ? industries[0].nameEn : industries[0].name;
            }
            return null;
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyListSectionWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* ContentWrapper */.vs, {
            isMarginTop: true,
            hasBg: true,
            hasBorder: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    children: [
                        title,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "(",
                                companyList[0] && ((ref = companyList[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.nbHits) || 0,
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFilter, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyIndustry/* default */.Z, {
                        options: state.companyIndustries,
                        value: selectedIndustries ? selectedIndustries[0] : -1,
                        placement: "bottom-end",
                        dropdownStyle: {
                            minWidth: langCode === constants/* ELanguage.EN */.Df.EN ? 450 : 400
                        },
                        langCode: langCode,
                        isMobile: isMobile,
                        onChange: function(e) {
                            return handleOnChangeFilterIndustries(e);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySlider, {
                    gutter: 16,
                    children: companyListMapped.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoResultWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_NoResultIcon, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        t("We found"),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordCount, {
                                            children: "0"
                                        }),
                                        " ",
                                        t("company matching with"),
                                        " ",
                                        t(mappedCompaniesName.length > 1 ? "industries" : "industry"),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Keyword, {
                                            children: [
                                                '"',
                                                mappedCompaniesName.join(", "),
                                                '"'
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearKeyword, {
                                    onClick: onClearFilter,
                                    children: t("Clear filter")
                                })
                            ]
                        })
                    }) : companyListMapped === null || companyListMapped === void 0 ? void 0 : companyListMapped.map(function(companyItem, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            sm: 8,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyCardSquare/* default */.Z, {
                                "data-id": "index-".concat(index),
                                companyInfo: companyItem,
                                user: user,
                                langCode: langCode,
                                baseMsUrl: "https://ms.vietnamworks.com",
                                baseImgUrl: "https://images.vietnamworks.com",
                                displayCompanyEvenHaveNoJob: true,
                                decryptToken: true,
                                initData: {
                                    locations: index_modern/* initialDataProvider.getLocations */.Bz.getLocations(),
                                    jobFunctions: index_modern/* initialDataProvider.getJobFunction */.Bz.getJobFunction(),
                                    companyIndustries: index_modern/* initialDataProvider.getIndustries */.Bz.getIndustries(),
                                    jobLevels: index_modern/* initialDataProvider.getLevels */.Bz.getLevels(),
                                    educations: index_modern/* initialDataProvider.getHighestDegrees */.Bz.getHighestDegrees(),
                                    countries: index_modern/* initialDataProvider.getCountries */.Bz.getCountries(),
                                    cities: index_modern/* initialDataProvider.getLocations */.Bz.getLocations(),
                                    districts: index_modern/* initialDataProvider.getDistricts */.Bz.getDistricts(),
                                    benefits: index_modern/* initialDataProvider.getBenefits */.Bz.getBenefits()
                                }
                            })
                        }, "company-item-".concat(index));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadMoreAction, {
                    style: {
                        display: isShowLoadMoreButton ? "flex" : "none"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onClickViewMore,
                        children: t("View more")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_CompanyListSection = (CompanyListSection);

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Input/index.js + 1 modules
var Input = __webpack_require__(46779);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/SearchIcon/index.js
var SearchIcon = __webpack_require__(6538);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useDebounce.js
var useDebounce = __webpack_require__(90401);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/urlBuilder.js
var urlBuilder = __webpack_require__(60332);
// EXTERNAL MODULE: ./helpers/common.ts + 3 modules
var common = __webpack_require__(3298);
;// CONCATENATED MODULE: ./components/CompanySearchHeader/api.ts



var DEFAULT_LIMIT_SUGGESTION_COUNT = 5;
var suggestCompany = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(keyword, langCode) {
        var suggestionCompanyResponse, companySuggestionList;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (keyword === "") {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        getCompanySuggestion(keyword, DEFAULT_LIMIT_SUGGESTION_COUNT, langCode)
                    ];
                case 1:
                    suggestionCompanyResponse = _state.sent();
                    if (!suggestionCompanyResponse || !suggestionCompanyResponse.data || typeof suggestionCompanyResponse.data !== "object") {
                        return [
                            2
                        ];
                    }
                    companySuggestionList = suggestionCompanyResponse.data.map(function(item) {
                        var ref, ref1, ref2;
                        var ref3, ref4, ref5, _companySlug;
                        return {
                            name: (ref3 = item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.companyName) !== null && ref3 !== void 0 ? ref3 : "",
                            id: (ref4 = item === null || item === void 0 ? void 0 : (ref1 = item.attributes) === null || ref1 === void 0 ? void 0 : ref1.companyId) !== null && ref4 !== void 0 ? ref4 : 0,
                            isCCP: (ref5 = item === null || item === void 0 ? void 0 : (ref2 = item.attributes) === null || ref2 === void 0 ? void 0 : ref2.isCCP) !== null && ref5 !== void 0 ? ref5 : 0,
                            companySlug: (_companySlug = item === null || item === void 0 ? void 0 : item.attributes.companySlug) !== null && _companySlug !== void 0 ? _companySlug : ""
                        };
                    });
                    return [
                        2,
                        companySuggestionList.length > 0 ? companySuggestionList : null
                    ];
            }
        });
    });
    return function suggestCompany(keyword, langCode) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/index.js + 570 modules
var components = __webpack_require__(71567);
;// CONCATENATED MODULE: ./components/CompanySearchHeader/CompanySearchHeader.css.tsx

function CompanySearchHeader_css_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    h1 {\n        color: #002c55;\n        font-size: 40px;\n        font-weight: 700;\n        margin-bottom: 8px;\n        @media screen and (max-width: ",
        "px) {\n            font-size: 19px;\n            text-align: center;\n        }\n    }\n    p {\n        color: #002c55;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 17px;\n        margin-bottom: 24px;\n    }\n    > div {\n        > div {\n            margin: 0;\n            > div {\n                margin-top: 0;\n            }\n        }\n    }\n    @media screen and (max-width: 768px) {\n        width: 100%;\n        p {\n            display: none;\n        }\n    }\n"
    ]);
    CompanySearchHeader_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanySearchHeader_css_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 70%;\n    background-color: #e6efff;\n    border-radius: 6px;\n    padding: 8px;\n    margin-bottom: 8px;\n    @media (max-width: 768px) {\n        width: 100%;\n    }\n"
    ]);
    CompanySearchHeader_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanySearchHeader_css_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            border-color: ",
        ";\n            input {\n                padding-right: 36px !important;\n            }\n        "
    ]);
    CompanySearchHeader_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanySearchHeader_css_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    border: 1px solid #a2a6ac;\n    background-color: #fff;\n    border-radius: 6px;\n    padding-left: 10px;\n    height: 40px;\n    padding-right: 0;\n    > div {\n        width: 100%;\n    }\n    input {\n        width: 100%;\n        border: none !important;\n        background-color: transparent !important;\n    }\n    &:hover {\n        border: 1px solid ",
        ";\n        box-shadow: none;\n        background-color: #fff;\n        input {\n            padding-right: 36px !important;\n        }\n    }\n    ",
        "\n"
    ]);
    CompanySearchHeader_css_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanySearchHeader_css_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    CompanySearchHeader_css_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var CompanySearchHeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4d8ed30e-0"
})(CompanySearchHeader_css_templateObject(), responsiveHelper/* screens.tablet */.FB.tablet);
var SearchCompany = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4d8ed30e-1"
})(CompanySearchHeader_css_templateObject1());
var InputWrapper = (0,styled_components_browser_esm/* default */.ZP)(Col/* default */.Z).withConfig({
    componentId: "sc-4d8ed30e-2"
})(CompanySearchHeader_css_templateObject3(), components.Colors.borderHover, function(param) {
    var isFocus = param.isFocus;
    if (!isFocus) {
        return "";
    }
    return (0,styled_components_browser_esm/* css */.iv)(CompanySearchHeader_css_templateObject2(), components.Colors.borderFocus);
});
var ButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(Col/* default */.Z).withConfig({
    componentId: "sc-4d8ed30e-3"
})(CompanySearchHeader_css_templateObject4());

;// CONCATENATED MODULE: ./components/CompanySearchHeader/translation.ts
var translation_translations = {
    Search: "T\xecm",
    "Find Your Best Working Place": "Kh\xe1m Ph\xe1 Văn Ho\xe1 C\xf4ng Ty",
    "Enter company name": "Nhập t\xean c\xf4ng ty",
    "Discover companies from the inside and find your best working place.": "T\xecm hiểu văn ho\xe1 c\xf4ng ty v\xe0 chọn cho bạn nơi l\xe0m việc ph\xf9 hợp nhất.",
    "No result": "Kh\xf4ng c\xf3 kết quả",
    "All Categories": "Tất Cả Ng\xe0nh Nghề"
};
/* harmony default export */ var CompanySearchHeader_translation = (translation_translations);

;// CONCATENATED MODULE: ./components/CompanySearchHeader/index.tsx












var DEBOUNCE_SUGGESTION_KEYWORD = 400;
var CompanySearchHeader = function(props) {
    var langCode = props.langCode, keywordFromUrl = props.keywordFromUrl, industriesFromUrl = props.industriesFromUrl, handleSearch = props.handleSearch, onChangeIndustries = props.onChangeIndustries;
    var isMobile = (0,store.useStore)().state.isMobile;
    // Form
    var ref = (0,react.useState)(keywordFromUrl), keyword = ref[0], setKeyword = ref[1];
    var ref1 = (0,react.useState)(industriesFromUrl), selectedIndustries = ref1[0], setSelectedIndustries = ref1[1];
    // End form
    var ref2 = (0,react.useState)([]), companySuggestionList = ref2[0], setCompanySuggestionList = ref2[1];
    var debouncedContent = (0,useDebounce/* default */.Z)([
        keyword
    ], DEBOUNCE_SUGGESTION_KEYWORD);
    var t = (0,react.useCallback)(function(text) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        } else {
            return CompanySearchHeader_translation[text];
        }
    }, [
        langCode
    ]);
    var handleOnKeyUp = function(e) {
        if (e.key === "Enter") {
            handleSearch(keyword, selectedIndustries);
        }
    };
    var handleChangeIndustries = function(value) {
        setSelectedIndustries(value);
        onChangeIndustries && onChangeIndustries([
            value
        ]);
    };
    (0,react.useEffect)(function() {
        setKeyword(keywordFromUrl);
    }, [
        keywordFromUrl
    ]);
    (0,react.useEffect)(function() {
        setSelectedIndustries(industriesFromUrl);
    }, [
        industriesFromUrl
    ]);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!debouncedContent) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            suggestCompany(keyword, langCode)
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response) {
                            response = [
                                {
                                    id: 0,
                                    name: t("No result"),
                                    isCCP: 0,
                                    companySlug: ""
                                }
                            ];
                        }
                        setCompanySuggestionList(response);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        debouncedContent,
        keyword,
        langCode,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanySearchHeaderWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: t("Find Your Best Working Place")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("Discover companies from the inside and find your best working place.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    gutter: [
                        0,
                        8
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 24,
                            sm: 20,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                type: "text",
                                value: keyword,
                                onChange: setKeyword,
                                placeholder: t("Enter company name"),
                                prefixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* default */.Z, {}),
                                onKeyUp: handleOnKeyUp,
                                style: {
                                    marginRight: 16
                                },
                                maxLength: 150,
                                listRecommend: companySuggestionList,
                                onClickSuggestionItem: function(item) {
                                    if (item.id === 0) {
                                        return;
                                    }
                                    var companyUrl = (0,urlBuilder/* buildCompanyLink */.S9)(item.id, item.companySlug || (0,common/* slugify */.lV)(item.name), item.companySlug, langCode, item.isCCP);
                                    if (false) {}
                                    window.location.href = companyUrl;
                                },
                                id: "company-search-input",
                                enterKeyHint: "search"
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                            xs: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                "data-id": "btn-search",
                                style: {
                                    width: "100%"
                                },
                                type: "primary",
                                onClick: function() {
                                    return handleSearch(keyword, selectedIndustries);
                                },
                                children: t("Search")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_CompanySearchHeader = (CompanySearchHeader);

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Skeleton/index.js
var Skeleton = __webpack_require__(19357);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/TrustedCompanyName/index.js + 2 modules
var TrustedCompanyName = __webpack_require__(78525);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./services/companyDetailService.ts + 1 modules
var companyDetailService = __webpack_require__(19886);
;// CONCATENATED MODULE: ./components/Icons/BriefcaseIcon/index.tsx


var BriefcaseIcon = function(props) {
    var style = props.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.2 2.40002C10.316 2.40002 9.59998 3.11602 9.59998 4.00002H3.19998C2.31598 4.00002 1.59998 4.71602 1.59998 5.60002V12.8C1.59998 13.684 2.31598 14.4 3.19998 14.4H20.8C21.684 14.4 22.4 13.684 22.4 12.8V5.60002C22.4 4.71602 21.684 4.00002 20.8 4.00002H14.4C14.4 3.11602 13.684 2.40002 12.8 2.40002H11.2ZM12 11.2C12.4416 11.2 12.8 11.5584 12.8 12C12.8 12.4416 12.4416 12.8 12 12.8C11.5584 12.8 11.2 12.4416 11.2 12C11.2 11.5584 11.5584 11.2 12 11.2ZM1.59998 15.5547V18.4C1.59998 19.284 2.31598 20 3.19998 20H20.8C21.684 20 22.4 19.284 22.4 18.4V15.5547C21.9272 15.8299 21.3856 16 20.8 16H3.19998C2.61438 16 2.07278 15.8299 1.59998 15.5547Z",
            fill: "#888"
        })
    });
};
/* harmony default export */ var Icons_BriefcaseIcon = (/*#__PURE__*/react.memo(BriefcaseIcon));

;// CONCATENATED MODULE: ./components/Icons/FolderIcon/index.tsx


var FolderIcon = function(props) {
    var style = props.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_533_6629)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.02887 4C3.19226 4 2.51464 4.67762 2.51464 5.51423V7.78557V9.29979H16.8998H20.6854V7.02845C20.6854 6.19184 20.0077 5.51423 19.1711 5.51423H9.47949L9.01221 4.73493C8.73889 4.27915 8.24613 4 7.71388 4H4.02887ZM2.13757 10.814C1.37364 10.814 0.82659 11.554 1.0507 12.2839L3.29837 19.5874C3.49447 20.2226 4.08131 20.6565 4.74606 20.6565H11.6H18.4539C19.1187 20.6565 19.7055 20.2226 19.9016 19.5874L22.1493 12.2839C22.3734 11.554 21.8264 10.814 21.0624 10.814H11.6H2.13757Z",
                    fill: "#888"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_533_6629",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_FolderIcon = (/*#__PURE__*/react.memo(FolderIcon));

;// CONCATENATED MODULE: ./components/Icons/FollowersIcon/index.tsx


var FollowersIcon = function(props) {
    var style = props.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12 4C9.4544 4 8.4 5.6328 8.4 7.6C8.4 8.2624 8.71719 8.92812 8.71719 8.92812C8.58999 9.00172 8.37845 9.23564 8.43125 9.64844C8.52965 10.418 8.86376 10.6121 9.07656 10.6281C9.15736 11.3465 9.9304 12.2664 10.2 12.4V13.4734C9.6 15.2734 4.8 15 4.8 19.2H19.2C19.2 15 14.4 15.2734 13.8 13.4734V12.4C14.0704 12.2664 14.8426 11.3465 14.9234 10.6281C15.1362 10.6121 15.4704 10.418 15.5688 9.64844C15.6215 9.23484 15.41 9.00172 15.2828 8.92812C15.2828 8.92812 15.6 8.3272 15.6 7.6C15.6 6.1432 15.028 4.9 13.8 4.9C13.8 4.9 13.3736 4 12 4ZM18 5.59844C17.5904 5.59844 17.2419 5.67253 16.9219 5.77813C17.0971 6.32133 17.2 6.9272 17.2 7.6C17.2 8.0256 17.1332 8.41579 17.0484 8.74219C17.1644 9.08539 17.2043 9.4628 17.1547 9.85C17.0419 10.7308 16.6999 11.3294 16.2703 11.7062C16.1455 12.0087 15.9746 12.2951 15.7906 12.5688C16.0178 13.0351 16.3504 13.4504 16.5 13.5344V13.5437C18.1296 14.3077 20.8 15.592 20.8 19.2H24C24 15.2336 20 15.8031 19.5 14.1031V13.5328C19.7248 13.4064 20.3687 12.5378 20.4359 11.8594C20.6127 11.8442 20.8918 11.6616 20.9734 10.9344C21.0174 10.544 20.8415 10.3243 20.7359 10.2547C20.7359 10.2547 21 9.6856 21 9C21 7.624 20.5232 6.45 19.5 6.45C19.5 6.45 19.1448 5.59844 18 5.59844ZM6 5.6C4.8552 5.6 4.5 6.45 4.5 6.45C3.4768 6.45 3 7.62556 3 9.00156C3 9.68796 3.26406 10.2547 3.26406 10.2547C3.15766 10.3235 2.98256 10.544 3.02656 10.9344C3.10816 11.6616 3.38726 11.8457 3.56406 11.8609C3.63126 12.5393 4.2752 13.408 4.5 13.5344V14.1031C4 15.8023 0 15.2336 0 19.2H3.2C3.2 15.592 5.8704 14.3085 7.5 13.5437V13.5328C7.6496 13.4488 7.98218 13.036 8.20938 12.5688C8.02538 12.2952 7.85449 12.0071 7.72969 11.7047C7.30009 11.3287 6.95731 10.73 6.84531 9.85C6.79491 9.458 6.83629 9.07453 6.95469 8.72813C6.86829 8.39933 6.8 8.0088 6.8 7.6C6.8 6.9384 6.89366 6.3302 7.06406 5.775C6.74806 5.6718 6.404 5.6 6 5.6Z",
            fill: "#888"
        })
    });
};
/* harmony default export */ var Icons_FollowersIcon = (/*#__PURE__*/react.memo(FollowersIcon));

;// CONCATENATED MODULE: ./components/CompanySearchItem/CompanySearchItem.css.tsx

function CompanySearchItem_css_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: #fff;\n    border-radius: 6px;\n    border: 1px solid #efefef;\n    padding: 16px;\n    margin-bottom: 8px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    @media (max-width: 768px) {\n        display: block;\n    }\n"
    ]);
    CompanySearchItem_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanySearchItem_css_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 70px;\n    height: 70px;\n    border-radius: 10px;\n    filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.1));\n    background-color: #fff;\n    margin-right: 16px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    align-content: center;\n    padding: 10px;\n    position: relative;\n    img {\n        width: 100%;\n        padding: 10px !important;\n        object-fit: contain;\n    }\n"
    ]);
    CompanySearchItem_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanySearchItem_css_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: ",
        ";\n    margin-right: 16px;\n    @media (max-width: 768px) {\n        margin-right: 0;\n        width: calc(100% - 86px);\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n    }\n"
    ]);
    CompanySearchItem_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanySearchItem_css_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: calc(100% - 100px);\n    margin-right: 16px;\n    @media (max-width: 768px) {\n        width: 100%;\n    }\n"
    ]);
    CompanySearchItem_css_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanySearchItem_css_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            > span > svg {\n                margin-right: 4px;\n            }\n        "
    ]);
    CompanySearchItem_css_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CompanySearchItem_css_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #777;\n    font-size: 13px;\n    line-height: 20px;\n    margin: 0 0 6px 0;\n    width: fit-content;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    display: flex;\n    span {\n        width: fit-content;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 1;\n    }\n    ",
        "\n"
    ]);
    CompanySearchItem_css_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CompanySearchItem_css_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100px;\n    display: flex;\n    justify-content: flex-end;\n    @media (max-width: 768px) {\n        display: block;\n        width: 100%;\n        margin-top: 8px;\n        > button {\n            width: 100%;\n        }\n    }\n"
    ]);
    CompanySearchItem_css_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CompanySearchItem_css_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 8px;\n"
    ]);
    CompanySearchItem_css_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CompanySearchItem_css_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #777;\n    font-size: 13px;\n    line-height: 20px;\n    margin-left: 16px;\n    > svg {\n        margin-right: 4px;\n    }\n"
    ]);
    CompanySearchItem_css_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var CompanyItemWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1280501f-0"
})(CompanySearchItem_css_templateObject());
var LogoSection = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-1280501f-1"
})(CompanySearchItem_css_templateObject1());
var ContentSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1280501f-2"
})(CompanySearchItem_css_templateObject2(), function(param) {
    var isShowFollow = param.isShowFollow;
    return isShowFollow ? "calc(100% - 186px)" : "calc(100% - 86px)";
});
var GroupContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1280501f-3"
})(CompanySearchItem_css_templateObject3());
var CompanyDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1280501f-4"
})(CompanySearchItem_css_templateObject5(), function(param) {
    var isFolderIcon = param.isFolderIcon;
    if (!isFolderIcon) {
        return "";
    }
    return (0,styled_components_browser_esm/* css */.iv)(CompanySearchItem_css_templateObject4());
});
var ActionSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1280501f-5"
})(CompanySearchItem_css_templateObject6());
var LocationName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1280501f-6"
})(CompanySearchItem_css_templateObject7());
var CompanyJobCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1280501f-7"
})(CompanySearchItem_css_templateObject8());

;// CONCATENATED MODULE: ./components/CompanySearchItem/index.tsx
















var CompanySearchItem = function(props) {
    var companyInfo = props.companyInfo;
    var _state = (0,store.useStore)().state, user = _state.user, t = _state.t, langCode = _state.langCode, isMobile = _state.isMobile;
    var ref = (0,react.useState)((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.isFollowed) === 1 || false), isFollow = ref[0], setFollowed = ref[1];
    var ref1 = (0,react.useState)((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) || 0), followCount = ref1[0], setFollowCount = ref1[1];
    var ref2 = (0,react.useState)(companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL) !== "" ? companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL : components_constants/* EMPTY_COMPANY_IMAGE */.I7), companyLogoImage = ref2[0], setCompanyLogoImage = ref2[1];
    var companyUrl = (0,common/* buildCompanyUrl */.kQ)((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0, (0,common/* slugify */.lV)((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) || ""), langCode);
    var isCCPAndOCI = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 1 || (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 3;
    if ((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) && isCCPAndOCI) {
        companyUrl = "/company/".concat(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companySlug);
    }
    var doFollow = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(isFollowed) {
            var response, toastTitle, toastMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!user) {
                            (0,common/* showLoginModal */.m8)(langCode);
                            return [
                                2
                            ];
                        }
                        if ((user === null || user === void 0 ? void 0 : user.accessToken) === null || (user === null || user === void 0 ? void 0 : user.accessToken) === "") {
                            (0,common/* showLoginModal */.m8)(langCode);
                            return [
                                2
                            ];
                        }
                        if (companyInfo === null || !companyInfo.companyId) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,companyDetailService/* companyFollow */.cP)(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId, isFollowed, (user === null || user === void 0 ? void 0 : user.accessToken) || "", langCode)
                        ];
                    case 1:
                        response = _state.sent();
                        if ((response === null || response === void 0 ? void 0 : response.code) !== jobService/* DEFAULT_SUCCESS_CODE */.se) {
                            return [
                                2
                            ];
                        }
                        setFollowed(isFollowed);
                        setFollowCount(isFollowed ? followCount + 1 : followCount - 1);
                        toastTitle = t("Unfollowed");
                        toastMessage = t("You'll stop receive the newest jobs from this company.");
                        if (isFollowed) {
                            toastTitle = t("Yay! Thanks for following");
                            toastMessage = t("You will receive the newest jobs from this company.");
                        }
                        Toast/* showToast */.CF(toastTitle, toastMessage, "success");
                        return [
                            2
                        ];
                }
            });
        });
        return function(isFollowed) {
            return _ref.apply(this, arguments);
        };
    }(), [
        companyInfo,
        followCount,
        langCode,
        t,
        user
    ]);
    var handleOnClickFollow = (0,react.useCallback)(function() {
        var followed = !isFollow;
        doFollow(followed);
    }, [
        doFollow,
        isFollow
    ]);
    (0,react.useEffect)(function() {
        if (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) {
            setFollowCount(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount);
        }
        if (companyInfo) {
            var companyLogo = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL) !== "" ? companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL : components_constants/* EMPTY_COMPANY_IMAGE */.I7;
            if (isCCPAndOCI) {
                companyLogo = companyInfo.companyLogoUrlCCP !== "" ? companyInfo.companyLogoUrlCCP : companyInfo.companyLogoURL;
            }
            if (companyLogo === "") {
                companyLogo = components_constants/* EMPTY_COMPANY_IMAGE */.I7;
            }
            setCompanyLogoImage(companyLogo);
        }
    }, [
        companyInfo
    ]);
    var industries = [];
    if (companyInfo) {
        var ref3, ref4;
        // FIXME - current assumption is using CCP first, fallback to normal industry
        industries = ((ref4 = (ref3 = companyInfo.industriesV3CCP || companyInfo.industriesV3) === null || ref3 === void 0 ? void 0 : ref3.map(function(industry) {
            return langCode === constants/* ELanguage.VI */.Df.VI ? industry.industryV3NameVI : industry.industryV3Name;
        })) === null || ref4 === void 0 ? void 0 : ref4.filter(function(industryName) {
            return !!industryName;
        })) || [];
        if (industries.length) {
            // @ts-ignore
            industries = (0,_to_consumable_array/* default */.Z)(new Set(industries));
        }
    }
    var companyName = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName;
    if ((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) && isCCPAndOCI && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyNameCCP) !== "") {
        companyName = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyNameCCP;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyItemWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoSection, {
                        href: companyUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: companyLogoImage,
                            alt: companyName,
                            priority: true,
                            layout: "fill",
                            placeholder: "blur",
                            blurDataURL: components_constants/* EMPTY_COMPANY_IMAGE */.I7,
                            onError: function() {
                                setCompanyLogoImage(components_constants/* EMPTY_COMPANY_IMAGE */.I7);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSection, {
                        isShowFollow: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustedCompanyName/* default */.Z, {
                                href: companyUrl,
                                name: companyName || "",
                                isTrusted: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 1,
                                style: {
                                    marginBottom: 4
                                },
                                tooltip: t("Trusted company")
                            }),
                            industries && (industries === null || industries === void 0 ? void 0 : industries.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyDescription, {
                                isFolderIcon: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FolderIcon, {}),
                                        " ",
                                        industries === null || industries === void 0 ? void 0 : industries.join(", ")
                                    ]
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyDescription, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FollowersIcon, {
                                                style: {
                                                    marginRight: 4
                                                }
                                            }),
                                            " ",
                                            followCount,
                                            " ",
                                            companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) > 1 ? t("followers") : t("follower")
                                        ]
                                    }),
                                    companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyJobCount, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BriefcaseIcon, {}),
                                            companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount,
                                            " ",
                                            (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) > 1 ? t("opening jobs") : t("opening job")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "primary",
                    isOutline: true,
                    size: isMobile ? "md" : "sm",
                    onClick: handleOnClickFollow,
                    children: isFollow ? t("Following") : t("Follow")
                })
            })
        ]
    });
};
/* harmony default export */ var components_CompanySearchItem = (CompanySearchItem);

;// CONCATENATED MODULE: ./components/CompanySearchResult/index.tsx








var CompanySearchResult = function(props) {
    var ref, ref1;
    var keyword = props.keyword, companyList = props.companyList, isHaveMore = props.isHaveMore, isSearching = props.isSearching, handleOnClickViewMore = props.handleOnClickViewMore, setKeyword = props.setKeyword, t = props.t;
    var ref2 = (0,react.useState)(""), noResultKeyword = ref2[0], setNoResultKeyword = ref2[1];
    var isMobile = (0,store.useStore)().state.isMobile;
    (0,react.useEffect)(function() {
        if (keyword !== "") {
            setNoResultKeyword(keyword);
        }
    }, [
        keyword
    ]);
    if (isSearching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySearchResultWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* ContentWrapper */.vs, {
                        isMarginTop: true,
                        isPadding: true,
                        hasBg: true,
                        hasBorder: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("Company Search Result")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchDescription, {
                                children: [
                                    t("We found"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordCount, {
                                        children: 0
                                    }),
                                    " ",
                                    t("company matching with"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                                        children: keyword
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanySearchResultListLoading, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 110
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 110
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 110
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 110
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 110
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 110
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 110
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 110
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 110
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 110
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySearchResultWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: companyList[0] && companyList[0].data && ((ref = companyList[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* ContentWrapper */.vs, {
                        isMarginTop: true,
                        isPadding: true,
                        isTransparentOnMobile: true,
                        disablePaddingMobile: true,
                        hasBg: true,
                        hasBorder: true,
                        children: [
                            isMobile ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("Company Search Result")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchDescription, {
                                children: [
                                    t("We found"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordCount, {
                                        children: companyList[0].meta.nbHits || 0
                                    }),
                                    " ",
                                    companyList[0].meta.nbHits && companyList[0].meta.nbHits > 1 ? t("companies matching with") : t("company matching with"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Keyword, {
                                        children: [
                                            '"',
                                            keyword,
                                            '"'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySearchResultList, {
                                children: companyList && companyList.map(function(companySearchResult, index) {
                                    return companySearchResult.data && companySearchResult.data.map(function(companyItem, companyIndex) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanySearchItem, {
                                            companyInfo: companyItem
                                        }, "company-search-item-".concat(index, "-").concat(companyIndex));
                                    });
                                })
                            }),
                            isHaveMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: handleOnClickViewMore,
                                    style: {
                                        width: 180
                                    },
                                    children: t("View more")
                                })
                            }) : null
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner_css/* ContentWrapper */.vs, {
                        isMarginTop: true,
                        isPadding: true,
                        hasBg: true,
                        hasBorder: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("No results found")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoResultWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_NoResultIcon, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            t("We found"),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordCount, {
                                                children: "0"
                                            }),
                                            " ",
                                            t("company matching with"),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Keyword, {
                                                children: [
                                                    '"',
                                                    noResultKeyword,
                                                    '"'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearKeyword, {
                                        onClick: function() {
                                            setKeyword("");
                                            var element = document.querySelector("#company-search-input");
                                            if (element === null) {
                                                return;
                                            }
                                            element.focus();
                                        },
                                        children: t("Clear keyword")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var components_CompanySearchResult = (CompanySearchResult);

// EXTERNAL MODULE: ./components/GotoTop/index.tsx + 2 modules
var GotoTop = __webpack_require__(93070);
// EXTERNAL MODULE: ./components/MasterLayout/index.tsx + 5 modules
var MasterLayout = __webpack_require__(9741);
;// CONCATENATED MODULE: ./components/CompanyListPage/translation.ts
var CompanyListPage_translation_translations = {
    Search: "T\xecm",
    "Companies Hiring Now": "C\xf4ng ty đang tuyển dụng",
    "Most Viewed Companies": "C\xf4ng ty xem nhiều nhất",
    "Most Followed Companies": "C\xf4ng ty theo d\xf5i nhiều nhất",
    "Featured Companies": "C\xf4ng ty nổi bật",
    "Search result for ": "Kết quả t\xecm kiếm cho ",
    "Company Search Result": "Kết Quả T\xecm Kiếm",
    "No results found": "Kh\xf4ng c\xf3 kết quả",
    "There is no company matches with your search": "Từ kho\xe1 t\xecm kiếm của bạn kh\xf4ng khớp với t\xean c\xf4ng ty n\xe0o",
    "We found": "Ch\xfang t\xf4i t\xecm thấy",
    "companies matching with": "c\xf4ng ty ph\xf9 hợp với",
    "company matching with": "c\xf4ng ty ph\xf9 hợp với",
    "category": "ng\xe0nh",
    "categories": "ng\xe0nh",
    "View more": "Xem th\xeam",
    "Searching": "Đang t\xecm",
    "Clear keyword": "Xo\xe1 từ kho\xe1"
};
/* harmony default export */ var CompanyListPage_translation = (CompanyListPage_translation_translations);

;// CONCATENATED MODULE: ./components/CompanyListPage/index.tsx
/* provided dependency */ var process = __webpack_require__(83454);

















var LIMIT_SEARCH_RESULT = 10;
var _NEXT_PUBLIC_MICROSERVICE_DOMAIN;
var msBaseUrl = (_NEXT_PUBLIC_MICROSERVICE_DOMAIN = process.env.NEXT_PUBLIC_MICROSERVICE_DOMAIN) !== null && _NEXT_PUBLIC_MICROSERVICE_DOMAIN !== void 0 ? _NEXT_PUBLIC_MICROSERVICE_DOMAIN : "";
var isOptOutUserAgentFilter = "0" === "1";
var CompanyListPage = function(props) {
    var appMode = props.appMode, langCode = props.langCode, jsToken = props.jsToken, wsToken = props.wsToken, user = props.user, _keywordFromUrl = props.keywordFromUrl, keywordFromUrl = _keywordFromUrl === void 0 ? "" : _keywordFromUrl, _industriesFromUrl = props.industriesFromUrl, industriesFromUrl = _industriesFromUrl === void 0 ? [] : _industriesFromUrl, seoKeywords = props.seoKeywords;
    var companyListProps = props.companyList;
    var ref = (0,store.useStore)(), state = ref.state, dispatch = ref.dispatch;
    (0,useIdentify/* default */.ZP)(user, msBaseUrl);
    // Search Section
    var ref1 = (0,react.useState)([]), searchResult = ref1[0], setSearchResult = ref1[1];
    var ref2 = (0,react.useState)(0), searchPage = ref2[0], setSearchPage = ref2[1];
    var ref3 = (0,react.useState)(false), isHaveMore = ref3[0], setHaveMore = ref3[1];
    // End search section
    var ref4 = (0,react.useState)(keywordFromUrl), keyword = ref4[0], setKeyword = ref4[1];
    var ref5 = (0,react.useState)(industriesFromUrl), selectedIndustry = ref5[0], setSelectedIndustry = ref5[1];
    // is search or default page
    var ref6 = (0,react.useState)(false), isSearch = ref6[0], setSearch = ref6[1];
    // currently calling API
    var ref7 = (0,react.useState)(false), isSearching = ref7[0], setSearching = ref7[1];
    var isMobile = state.isMobile;
    var t = (0,react.useCallback)(function(text) {
        if (langCode === constants/* ELanguage.EN */.Df.EN) {
            return text;
        } else {
            return CompanyListPage_translation[text];
        }
    }, [
        langCode
    ]);
    var updateHistory = function(searchKeyword, searchCategories) {
        // bring keyword to url by history.pushState
        if (true) {
            var _location = window.location, origin = _location.origin, pathname = _location.pathname;
            var url = "".concat(origin).concat(pathname);
            if (searchKeyword !== "") {
                url = "".concat(url, "?keyword=").concat(searchKeyword);
            }
            if (searchCategories && searchCategories.length > 0) {
                if (searchKeyword !== "") {
                    url = "".concat(url, "&");
                } else {
                    url = "".concat(url, "?");
                }
                url = "".concat(url, "category=").concat(searchCategories.join(","));
            }
            history.pushState(null, "", url);
        }
    };
    var doSearch = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var ref, _searchKeyword, searchKeyword, _searchIndustries, searchIndustries, _page, page, filterPage, industries, userId, filters, _tmp, searchFilter, _tmp1, accessToken, companyListResult, isHaveMoreResult;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _searchKeyword = param.searchKeyword, searchKeyword = _searchKeyword === void 0 ? "" : _searchKeyword, _searchIndustries = param.searchIndustries, searchIndustries = _searchIndustries === void 0 ? [] : _searchIndustries, _page = param.page, page = _page === void 0 ? null : _page;
                        setSearching(true);
                        filterPage = page !== null ? page : searchPage;
                        if (searchKeyword !== "") {
                            // It is branch new search, so we need to reset page index to zero
                            filterPage = 0;
                        }
                        industries = searchIndustries;
                        if (searchIndustries.length === 0) {
                            industries = selectedIndustry;
                        }
                        userId = user && (user === null || user === void 0 ? void 0 : user.userId) ? user === null || user === void 0 ? void 0 : user.userId : 0;
                        filters = [];
                        _tmp = {};
                        if (industries.length > 0) {
                            filters.push((_tmp.field = "industries.industryId", _tmp.value = industries.join(","), _tmp));
                        }
                        _tmp1 = {};
                        searchFilter = (_tmp1.query = searchKeyword !== "" ? searchKeyword : keyword, _tmp1.order = [], _tmp1.facets = [], _tmp1.hitsPerPage = LIMIT_SEARCH_RESULT, _tmp1.filter = filters, _tmp1.page = filterPage, _tmp1.userId = userId, _tmp1.isJobs = true, _tmp1);
                        accessToken = (user === null || user === void 0 ? void 0 : user.accessToken) ? user === null || user === void 0 ? void 0 : user.accessToken : "";
                        return [
                            4,
                            getCompanyList(searchFilter, langCode, accessToken)
                        ];
                    case 1:
                        companyListResult = _state.sent();
                        if (!(companyListResult === null || companyListResult === void 0 ? void 0 : companyListResult.data)) {
                            setHaveMore(false);
                            setSearching(false);
                            return [
                                2
                            ];
                        }
                        if (searchKeyword !== "") {
                            // It is branch new search, so we need to clear old search result
                            setSearchResult([
                                companyListResult
                            ]);
                        } else {
                            // User click on "View more"
                            setSearchResult((0,_to_consumable_array/* default */.Z)(searchResult).concat([
                                companyListResult
                            ]));
                        }
                        isHaveMoreResult = filterPage + 1 < ((companyListResult === null || companyListResult === void 0 ? void 0 : (ref = companyListResult.meta) === null || ref === void 0 ? void 0 : ref.nbPages) || 0);
                        setHaveMore(isHaveMoreResult);
                        setSearching(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(param) {
            return _ref.apply(this, arguments);
        };
    }(), [
        keyword,
        selectedIndustry,
        langCode,
        searchPage,
        searchResult,
        user
    ]);
    var handleSearch = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(keyword, category) {
            var trimmedKeyword, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                trimmedKeyword = keyword.trim();
                setSearch(trimmedKeyword !== "");
                setKeyword(trimmedKeyword);
                _tmp = {};
                doSearch((_tmp.searchKeyword = trimmedKeyword, _tmp));
                updateHistory(trimmedKeyword, category);
                _tmp1 = {};
                if (trimmedKeyword === "") {
                    dispatch((_tmp1.type = actions/* ACTION_SET_COMPANY_LIST */.jM, _tmp1.payload = companyListProps, _tmp1));
                }
                return [
                    2
                ];
            });
        });
        return function(keyword, category) {
            return _ref.apply(this, arguments);
        };
    }(), [
        doSearch
    ]);
    var handleOnClickViewMore = function() {
        var nextPage = searchPage + 1;
        setSearchPage(nextPage);
        doSearch({
            page: nextPage
        });
    };
    var handlePopstate = function() {
        var url = window.location.href;
        var keywordOnPop = getParamFromUrl("keyword", url);
        // TODO: on popstate
        setSearch(keywordOnPop !== "");
        setKeyword(keywordOnPop);
        doSearch({
            searchKeyword: keywordOnPop
        });
        if (true) {
            // Scroll to top on popState
            setTimeout(function() {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }, 500);
        }
    };
    var updateUserState = function(e) {
        var ref, ref1, ref2;
        if (!(e === null || e === void 0 ? void 0 : (ref = e.detail) === null || ref === void 0 ? void 0 : ref.user)) {
            return;
        }
        dispatch({
            type: actions/* ACTION_SET_USER */.gS,
            payload: e === null || e === void 0 ? void 0 : (ref1 = e.detail) === null || ref1 === void 0 ? void 0 : ref1.user
        });
        fetchCompanyList(e === null || e === void 0 ? void 0 : (ref2 = e.detail) === null || ref2 === void 0 ? void 0 : ref2.user);
    };
    var fetchCompanyList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(user) {
            var rangesFilter, _tmp, featuredCompanyList, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(user === null || user === void 0 ? void 0 : user.accessToken)) {
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        rangesFilter = [
                            (_tmp.field = "companyId", _tmp.operator = ">", _tmp.value = "0", _tmp)
                        ];
                        _tmp1 = {};
                        return [
                            4,
                            getCompanyList((_tmp1.query = "", _tmp1.order = [
                                {
                                    field: "lastPostJobOn",
                                    value: "desc"
                                }
                            ], _tmp1.hitsPerPage = components_constants/* LIMIT_COMPANY_LIST */.jg, _tmp1.filter = [
                                {
                                    field: "profilePublishedSiteMask",
                                    value: "1,3"
                                }
                            ], _tmp1.regexp = [
                                {
                                    field: "companySlug",
                                    value: ".+"
                                }
                            ], _tmp1.ranges = rangesFilter, _tmp1.userId = user === null || user === void 0 ? void 0 : user.userId, _tmp1.isJobs = true, _tmp1), langCode, user === null || user === void 0 ? void 0 : user.accessToken)
                        ];
                    case 1:
                        featuredCompanyList = _state.sent();
                        _tmp2 = {};
                        dispatch((_tmp2.type = actions/* ACTION_SET_COMPANY_LIST */.jM, _tmp2.payload = [
                            featuredCompanyList
                        ], _tmp2));
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchCompanyList(user) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (true) {
            // Scroll to top
            setTimeout(function() {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }, 500);
            window.addEventListener("popstate", handlePopstate);
            window.addEventListener(components_constants/* UPDATE_USER */.AX, updateUserState);
        }
        return function() {
            window.removeEventListener("popstate", handlePopstate);
            window.removeEventListener(components_constants/* UPDATE_USER */.AX, updateUserState);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (user === null) {
            return;
        }
        dispatch({
            type: actions/* ACTION_SET_USER */.gS,
            payload: user
        });
    }, [
        dispatch,
        user
    ]);
    (0,react.useEffect)(function() {
        if (companyListProps.length === 0) {
            return;
        }
        dispatch({
            type: actions/* ACTION_SET_COMPANY_LIST */.jM,
            payload: companyListProps
        });
    }, [
        dispatch,
        companyListProps
    ]);
    (0,react.useEffect)(function() {
        setKeyword(keywordFromUrl);
        if (keywordFromUrl !== "") {
            setSearch(true);
            doSearch({
                searchKeyword: keywordFromUrl,
                searchIndustries: industriesFromUrl
            });
            updateHistory(keywordFromUrl, industriesFromUrl);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        keywordFromUrl,
        industriesFromUrl
    ]);
    var _NEXT_PUBLIC_POSTHOG_API_KEY, _NEXT_PUBLIC_POSTHOG_API_HOST;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HogProvider/* default */.Z, {
        posthogConfig: {
            key: (_NEXT_PUBLIC_POSTHOG_API_KEY = "phc_MPcl1lKQzHItt2rWP3yrQgoIeqjtTgJ4ngki2IWCP5A") !== null && _NEXT_PUBLIC_POSTHOG_API_KEY !== void 0 ? _NEXT_PUBLIC_POSTHOG_API_KEY : "",
            host: (_NEXT_PUBLIC_POSTHOG_API_HOST = "https://pht.vietnamworks.com") !== null && _NEXT_PUBLIC_POSTHOG_API_HOST !== void 0 ? _NEXT_PUBLIC_POSTHOG_API_HOST : "",
            options: {
                optOutUserAgentFilter: isOptOutUserAgentFilter
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MasterLayout/* default */.Z, {
            seoKeywords: seoKeywords,
            appMode: appMode,
            langCode: langCode,
            jsToken: jsToken,
            wsToken: wsToken,
            isMobileScale: isMobile,
            noPaddingResponsiveContainer: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    id: "topCompanyList",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanySearchHeader, {
                            keywordFromUrl: keyword,
                            industriesFromUrl: selectedIndustry,
                            langCode: langCode,
                            handleSearch: handleSearch,
                            onChangeIndustries: function(value) {
                                setSelectedIndustry(value);
                                doSearch({
                                    searchKeyword: keyword,
                                    searchIndustries: value
                                });
                            }
                        })
                    })
                }),
                isSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanySearchResult, {
                    t: t,
                    companyList: searchResult,
                    keyword: keyword,
                    setKeyword: setKeyword,
                    isSearching: isSearching,
                    isHaveMore: isHaveMore,
                    handleOnClickViewMore: handleOnClickViewMore
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyListSection, {
                            title: t("Featured Companies"),
                            langCode: langCode
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GotoTop/* default */.Z, {
                    trackId: "topCompanyList"
                })
            ]
        })
    });
};
/* harmony default export */ var components_CompanyListPage = (CompanyListPage);


/***/ })

}]);